import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import safeHtml from "../../utils/safeHtml";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES, CDN_ASSETS } from "../../utils/cdn";
import localNavigation from "../../data/navigation.json";
import "./index.css";

function HeroBanner() {
  const location = useLocation();
  const [navigation, setNavigation] = useState(localNavigation);

  useEffect(() => {
    let isMounted = true;
    fetchJsonWithFallback(CDN_INCLUDES + "navigation.json", localNavigation).then((data) => {
      if (isMounted) setNavigation(data);
    });
    return () => { isMounted = false; };
  }, []);

  const { heroTitles = {} } = navigation || {};
  const isHero = Object.prototype.hasOwnProperty.call(heroTitles, location.pathname);
  const heroTitle = heroTitles[location.pathname];

  if (!isHero) return null;

  const isHome = location.pathname === "/";

  const isLowSubpage = ["/About", "/Contact"].includes(location.pathname);

  return (
    <div
      className="hero-banner"
      style={{ "--hero-bg-image": `url(${CDN_ASSETS}hero-background-image.webp)` }}
    >
      {heroTitle && (
        <div className={`hero-banner__content${isHome ? " hero-banner__content--home" : isLowSubpage ? " hero-banner__content--subpage-low" : " hero-banner__content--subpage"}`}>
          <h1 className={`hero-banner__tagline${!isHome ? " hero-banner__tagline--subpage" : ""}`}>{safeHtml(heroTitle)}</h1>
        </div>
      )}
    </div>
  );
}

export default HeroBanner;
